<template lang="pug">
  div.media-views
    module-title(title="媒体观点聚合")
    div.lists
      div.list(v-for="(l, i) in lists" :key="i")
        p.title(:title="l.title") {{l.title}}
        div.bar(@click="showChannel(l)")
          span.num(:style="{left: `${l.width}`}") {{l.num}}
          div.value(:style="{width: l.width}")
          div.channels(v-show="l.showChannel")
            div.items
              div.item(v-for="c in l.sources")
                div.radius
                label {{c.nick}}
                a.time(:href="c.url" target="_blank") {{c.publishTime}}
</template>

<script>
import ModuleTitle from '../EventCenter/ModuleTitle'
import client from '../server/server'
import moment from 'moment'
export default {
  name: 'MediaViews',
  components: {
    ModuleTitle
  },
  data () {
    return {
      lists: []
    }
  },
  mounted () {
    this.getMediaView()
  },
  methods: {
    showChannel (l) {
      l.showChannel = !l.showChannel
    },
    getMediaView () {
      let params = {
        id: this.$route.params.id
      }
      client.getEventMediaViews(params)
        .then(res => {
          if (res.success) {
            let max = res.data.length && (res.data[0].num / 0.8)

            this.lists = res.data.map(d => {
              let sources = d.sources.map(x => {
                return Object.assign({}, x, {
                  publishTime: moment(x.publishTime).format('YYYY/MM/DD HH:mm')
                })
              })
              return Object.assign({}, d, {
                width: `${d.num / max * 100}%`,
                showChannel: false,
                sources: sources
              })
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/common";

.media-views {
  width: 0;
  flex: 7;
  height: 760px;
  background-color: #ffffff;
  border-radius: 4px;
  margin-right: 20px;
  padding: 14px;

  .lists {
    padding: 10px 24px 10px 10px;

    .list {
      p.title {
        margin-top: 20px;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .bar {
        margin-top: 10px;
        height: 18px;
        background-color: #f5f6fa;
        border-radius: 0 9px 9px 0;
        position: relative;
        cursor: pointer;

        .num {
          position: absolute;
          right: -30px;
          top: 50%;
          transform: translate(5px, -50%);
          color: #3989cb;
        }

        .value {
          height: 18px;
          background-color: #3989cb;
          border-radius: 0 9px 9px 0;
          position: relative;
        }

        .channels {
          width: 300px;
          height: 240px;
          overflow-y: auto;
          @include scrollBar;
          background-color: #ffffff;
          border-radius: 4px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.06);
          position: absolute;
          top: 20px;
          right: 0;
          z-index: 2;
          padding: 10px 18px;
          font-size: 12px;

          .items {
            border-left: 1px solid #eee;

            .item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 5px 0;
              color: #999;
              position: relative;

              .radius {
                position: absolute;
                left: 0;
                top: 50%;
                transform: translate(-4px, -50%);
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: #ffffff;
                border: solid 1px #eeeeee;
              }

              label {
                color: #666;
                margin-left: 15px;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventViews/MediaViews.vue